import { useEffect } from 'react';

export function useLockBodyScroll(lock: boolean) {
  useEffect(() => {
    if (lock) {
      // Disable scrolling by hiding overflow
      document.body.style.overflow = 'hidden';
    } else {
      // Re-enable scrolling by resetting overflow
      document.body.style.overflow = '';
    }

    // Cleanup function to ensure the body style is reset
    return () => {
      document.body.style.overflow = '';
    };
  }, [lock]);
};
